import { PosTimeService } from "../services/pos.time.service";
export class POSTimeClock {
	day!: string;
	timeHour!: string;
	timeMinute!: string;
	timeMeridian!: string;
	timeZone!: string;
	constructor(private postimerService: PosTimeService) {}
	init(
		isMilitaryTime: boolean,
		isAutoUpdateInSec: boolean,
		updateInInterval?: number
	) {
		updateInInterval = isAutoUpdateInSec ? 1000 : updateInInterval;
		setInterval(() => {
			this.startTime(isMilitaryTime);
		}, updateInInterval);
	}
	private startTime(isMilitaryTime: boolean) {
		const date: Date = this.postimerService.getCurrentTime();
		this.day = date.formatter('D');
		this.timeHour = date.formatter(isMilitaryTime ? 'H' : 'h');
		this.timeMinute = date.formatter('i');
		this.timeMeridian = date.formatter(isMilitaryTime ? '' : 'P');
		this.timeZone = this.postimerService.getTimeZoneName().replace(/\_/, ' ');
	}
}
